/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import { LEGACY_RUBRIC_VERSION } from '../../constants';

/**
 * Resolve rubric version from API/Mongo payload. Missing or invalid values default to 1.
 * @param {unknown} value
 * @returns {number}
 */
export function resolveRubricVersion(value) {
  if (value == null || value === '') {
    return LEGACY_RUBRIC_VERSION;
  }
  const n = Number(value);
  if (!Number.isFinite(n) || n < 1) {
    return LEGACY_RUBRIC_VERSION;
  }
  return Math.floor(n);
}

/**
 * When the list API returns multiple versions per rubricId, keep only the latest.
 * @param {Array<{ rubricId?: string, rubricVersion?: number }>} items
 * @returns {typeof items}
 */
export function dedupeEvaluationsToLatestVersions(items) {
  if (!Array.isArray(items) || items.length <= 1) {
    return Array.isArray(items) ? items : [];
  }

  const byRubricId = new Map();
  items.forEach((item) => {
    if (!item?.rubricId) {
      return;
    }
    const key = String(item.rubricId);
    const version = resolveRubricVersion(item.rubricVersion);
    const normalized = { ...item, rubricVersion: version };
    const existing = byRubricId.get(key);
    if (!existing || resolveRubricVersion(existing.rubricVersion) < version) {
      byRubricId.set(key, normalized);
    }
  });

  return [...byRubricId.values()];
}
